// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * YovoTrip Design Tokens
 * 
 * Global CSS custom properties for colors, typography, spacing, and radii.
 * All variables are prefixed with --yovo- to prevent conflicts with
 * third-party libraries (MUI, datepicker, etc.).
 *
 * Usage:  color: var(--yovo-base-black);
 *         background: var(--yovo-grey-100);
 *
 * Import this file once at the app root (index.css or App entry).
 * Component-level CSS can then reference any token without re-importing.
 *
 * Figma design system parity (Yovotrip file):
 *   Neutrals/Base-white  → --yovo-base-white
 *   Neutrals/grey-200    → --yovo-grey-200
 *   Primary/yovo-red-400 → --yovo-brand-red
 */

:root {
  /* ===== Neutrals: Base ===== */
  --yovo-base-black:   #20202A;
  /* Figma: Neutrals/Base-white (#fbfbfb) */
  --yovo-base-white:   #FBFBFB;

  /* ===== Neutrals: Grey Scale ===== */
  --yovo-grey-100:     #F5F5F7;
  /* Figma: Neutrals/grey-200 (#e8e9ed) */
  --yovo-grey-200:     #E8E9ED;
  --yovo-grey-300:     #D6D9E0;
  --yovo-grey-400:     #C5C8D4;
  --yovo-grey-500:     #C3C3CD;
  --yovo-grey-600:     #A0A0A8;
  /* 4.9:1 on the homepage canvas #F5F5F7. #7E808F was 3.6:1. */
  --yovo-grey-700:     #686A7A;
  /* Same step, both casings. Components use either name. */
  --Neutrals-grey-700: #686A7A;
  --neutrals-grey-700: #686A7A;
  /* 5.0:1 on the footer #111827. #6B7280 was 3.7:1. */
  --yovo-text-on-dark-muted: #848896;
  --yovo-grey-800:     #545665;
  --yovo-grey-900:     #383A47;

  /* ===== Brand ===== */
  /* Figma: Primary/yovo-red-400 (#cf2048) */
  --yovo-brand-red:    #CF2048;
  --yovo-brand-red-dark: #8A112D;
  --yovo-brand-red-hover: #AB2645;
  --yovo-brand-accent: #444B94;

  /* ===== Functional ===== */
  --yovo-error:        #D32F2F;
  --yovo-warning:      #E65100;
  --yovo-warning-bg:   #FFF3E0;
  --yovo-border:       #D0D0D0;

  /* ===== Typography: Font Families ===== */
  --yovo-font-host-grotesk: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android';
  --yovo-font-primary:    var(--yovo-font-host-grotesk), -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, sans-serif;
  --yovo-font-display:    'Unbounded', 'Host Grotesk', sans-serif;
  --yovo-font-secondary:  'Red Hat Display', 'Host Grotesk', sans-serif;

  /* ===== Typography: Font Sizes ===== */
  --yovo-text-xs:     10px;
  --yovo-text-sm:     12px;
  --yovo-text-base:   14px;
  --yovo-text-md:     16px;
  --yovo-text-lg:     20px;
  --yovo-text-xl:     24px;

  /* ===== Typography: Line Heights ===== */
  --yovo-leading-xs:  14px;
  --yovo-leading-sm:  16px;
  --yovo-leading-base: 20px;
  --yovo-leading-md:  24px;
  --yovo-leading-lg:  28px;

  /* ===== Typography: Letter Spacing ===== */
  --yovo-tracking-tight:  0.15px;
  --yovo-tracking-normal: 0.25px;
  --yovo-tracking-wide:   0.37px;
  --yovo-tracking-wider:  0.4px;

  /* ===== Spacing ===== */
  --yovo-space-xs:    4px;
  --yovo-space-sm:    8px;
  --yovo-space-md:    12px;
  --yovo-space-base:  16px;
  --yovo-space-lg:    20px;
  --yovo-space-xl:    24px;
  --yovo-space-2xl:   32px;
  --yovo-space-3xl:   48px;

  /* ===== Border Radii ===== */
  --yovo-radius-sm:   8px;
  --yovo-radius-md:   12px;
  --yovo-radius-lg:   16px;
  --yovo-radius-xl:   20px;
  --yovo-radius-pill:  24px;
  --yovo-radius-full: 9999px;

  /* ===== Shadows ===== */
  --yovo-shadow-sm:   0 2px 8px rgba(0, 0, 0, 0.08);
  --yovo-shadow-md:   0 4px 16px rgba(0, 0, 0, 0.10);
  --yovo-shadow-lg:   0 4px 20px rgba(0, 0, 0, 0.12);
  --yovo-shadow-xl:   0 12px 36px rgba(0, 0, 0, 0.14);
  --yovo-shadow-card: 0 0 23px 0 rgba(157, 157, 157, 0.25);

  /* ===== Transitions ===== */
  --yovo-transition-fast:   0.1s ease;
  --yovo-transition-normal: 0.2s ease;
  --yovo-transition-slow:   0.3s ease;

  /* ===== Z-Index Scale ===== */
  --yovo-z-header:    10;
  --yovo-z-dropdown:  100;
  --yovo-z-modal:     1000;
  --yovo-z-tooltip:   9999;
  --yovo-z-portal:    99999;

  /* ===== iOS/Safari: minimum tap target ===== */
  --yovo-tap-min:     44px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/yovo-tokens.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;EAiBE;;AAEF;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,yCAAyC;EACzC,4BAA4B;;EAE5B,qCAAqC;EACrC,4BAA4B;EAC5B,uCAAuC;EACvC,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,6DAA6D;EAC7D,4BAA4B;EAC5B,yDAAyD;EACzD,4BAA4B;EAC5B,4BAA4B;EAC5B,oDAAoD;EACpD,kCAAkC;EAClC,4BAA4B;EAC5B,4BAA4B;;EAE5B,sBAAsB;EACtB,0CAA0C;EAC1C,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,4BAA4B;;EAE5B,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;;EAE5B,0CAA0C;EAC1C,kGAAkG;EAClG,mIAAmI;EACnI,+DAA+D;EAC/D,qEAAqE;;EAErE,uCAAuC;EACvC,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;;EAExB,yCAAyC;EACzC,wBAAwB;EACxB,wBAAwB;EACxB,yBAAyB;EACzB,wBAAwB;EACxB,wBAAwB;;EAExB,2CAA2C;EAC3C,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,6BAA6B;;EAE7B,wBAAwB;EACxB,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;;EAExB,6BAA6B;EAC7B,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,yBAAyB;EACzB,0BAA0B;;EAE1B,wBAAwB;EACxB,iDAAiD;EACjD,kDAAkD;EAClD,kDAAkD;EAClD,mDAAmD;EACnD,wDAAwD;;EAExD,4BAA4B;EAC5B,mCAAmC;EACnC,mCAAmC;EACnC,mCAAmC;;EAEnC,8BAA8B;EAC9B,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,yBAAyB;;EAEzB,+CAA+C;EAC/C,wBAAwB;AAC1B","sourcesContent":["/*\n * YovoTrip Design Tokens\n * \n * Global CSS custom properties for colors, typography, spacing, and radii.\n * All variables are prefixed with --yovo- to prevent conflicts with\n * third-party libraries (MUI, datepicker, etc.).\n *\n * Usage:  color: var(--yovo-base-black);\n *         background: var(--yovo-grey-100);\n *\n * Import this file once at the app root (index.css or App entry).\n * Component-level CSS can then reference any token without re-importing.\n *\n * Figma design system parity (Yovotrip file):\n *   Neutrals/Base-white  → --yovo-base-white\n *   Neutrals/grey-200    → --yovo-grey-200\n *   Primary/yovo-red-400 → --yovo-brand-red\n */\n\n:root {\n  /* ===== Neutrals: Base ===== */\n  --yovo-base-black:   #20202A;\n  /* Figma: Neutrals/Base-white (#fbfbfb) */\n  --yovo-base-white:   #FBFBFB;\n\n  /* ===== Neutrals: Grey Scale ===== */\n  --yovo-grey-100:     #F5F5F7;\n  /* Figma: Neutrals/grey-200 (#e8e9ed) */\n  --yovo-grey-200:     #E8E9ED;\n  --yovo-grey-300:     #D6D9E0;\n  --yovo-grey-400:     #C5C8D4;\n  --yovo-grey-500:     #C3C3CD;\n  --yovo-grey-600:     #A0A0A8;\n  /* 4.9:1 on the homepage canvas #F5F5F7. #7E808F was 3.6:1. */\n  --yovo-grey-700:     #686A7A;\n  /* Same step, both casings. Components use either name. */\n  --Neutrals-grey-700: #686A7A;\n  --neutrals-grey-700: #686A7A;\n  /* 5.0:1 on the footer #111827. #6B7280 was 3.7:1. */\n  --yovo-text-on-dark-muted: #848896;\n  --yovo-grey-800:     #545665;\n  --yovo-grey-900:     #383A47;\n\n  /* ===== Brand ===== */\n  /* Figma: Primary/yovo-red-400 (#cf2048) */\n  --yovo-brand-red:    #CF2048;\n  --yovo-brand-red-dark: #8A112D;\n  --yovo-brand-red-hover: #AB2645;\n  --yovo-brand-accent: #444B94;\n\n  /* ===== Functional ===== */\n  --yovo-error:        #D32F2F;\n  --yovo-warning:      #E65100;\n  --yovo-warning-bg:   #FFF3E0;\n  --yovo-border:       #D0D0D0;\n\n  /* ===== Typography: Font Families ===== */\n  --yovo-font-host-grotesk: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android';\n  --yovo-font-primary:    var(--yovo-font-host-grotesk), -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, sans-serif;\n  --yovo-font-display:    'Unbounded', 'Host Grotesk', sans-serif;\n  --yovo-font-secondary:  'Red Hat Display', 'Host Grotesk', sans-serif;\n\n  /* ===== Typography: Font Sizes ===== */\n  --yovo-text-xs:     10px;\n  --yovo-text-sm:     12px;\n  --yovo-text-base:   14px;\n  --yovo-text-md:     16px;\n  --yovo-text-lg:     20px;\n  --yovo-text-xl:     24px;\n\n  /* ===== Typography: Line Heights ===== */\n  --yovo-leading-xs:  14px;\n  --yovo-leading-sm:  16px;\n  --yovo-leading-base: 20px;\n  --yovo-leading-md:  24px;\n  --yovo-leading-lg:  28px;\n\n  /* ===== Typography: Letter Spacing ===== */\n  --yovo-tracking-tight:  0.15px;\n  --yovo-tracking-normal: 0.25px;\n  --yovo-tracking-wide:   0.37px;\n  --yovo-tracking-wider:  0.4px;\n\n  /* ===== Spacing ===== */\n  --yovo-space-xs:    4px;\n  --yovo-space-sm:    8px;\n  --yovo-space-md:    12px;\n  --yovo-space-base:  16px;\n  --yovo-space-lg:    20px;\n  --yovo-space-xl:    24px;\n  --yovo-space-2xl:   32px;\n  --yovo-space-3xl:   48px;\n\n  /* ===== Border Radii ===== */\n  --yovo-radius-sm:   8px;\n  --yovo-radius-md:   12px;\n  --yovo-radius-lg:   16px;\n  --yovo-radius-xl:   20px;\n  --yovo-radius-pill:  24px;\n  --yovo-radius-full: 9999px;\n\n  /* ===== Shadows ===== */\n  --yovo-shadow-sm:   0 2px 8px rgba(0, 0, 0, 0.08);\n  --yovo-shadow-md:   0 4px 16px rgba(0, 0, 0, 0.10);\n  --yovo-shadow-lg:   0 4px 20px rgba(0, 0, 0, 0.12);\n  --yovo-shadow-xl:   0 12px 36px rgba(0, 0, 0, 0.14);\n  --yovo-shadow-card: 0 0 23px 0 rgba(157, 157, 157, 0.25);\n\n  /* ===== Transitions ===== */\n  --yovo-transition-fast:   0.1s ease;\n  --yovo-transition-normal: 0.2s ease;\n  --yovo-transition-slow:   0.3s ease;\n\n  /* ===== Z-Index Scale ===== */\n  --yovo-z-header:    10;\n  --yovo-z-dropdown:  100;\n  --yovo-z-modal:     1000;\n  --yovo-z-tooltip:   9999;\n  --yovo-z-portal:    99999;\n\n  /* ===== iOS/Safari: minimum tap target ===== */\n  --yovo-tap-min:     44px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
